import React from 'react';

import './CustomToggleButton.scss';
import {ToggleButton} from "primereact/togglebutton";

type TimeDropdownProps = {
    active: boolean,
    setActive(newValue: boolean): void
}

const CustomToggleButton = ({active, setActive}: TimeDropdownProps) => {
    return <div className="custom-toggle-button">
            <ToggleButton className={"p-button-sm"}
                          onIcon={"pi pi-power-off"}
                          offIcon={"pi pi-power-off"}
                          onLabel={""}
                          offLabel={""}
                          checked={active}
                          onChange={(e) => {
                                  setActive(e.value)
                          }}
                          tooltip={active?"Auto-refresh turned on":"Auto-refresh turned off"}
                          tooltipOptions={{position: "bottom"}}
            />
    </div>
};

export default CustomToggleButton;